module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-cebrity-vin-diesel-4f71e510f00c5e7da7de489ae436a74b.png";